// Angular import
import { Component, effect, inject, input } from '@angular/core';
import { Location, LocationStrategy } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// project import
import { NavigationItem } from 'src/app/@theme/types/navigation';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { HORIZONTAL, VERTICAL, COMPACT } from 'src/app/@theme/const';
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { MenuGroupVerticalComponent } from './menu-group/menu-group.component';
import { MenuItemVerticalComponent } from './menu-item/menu-item.component';
import { AuthenticationService } from 'src/app/@theme/services/authentication.service';
import { MenuCollapseComponent } from './menu-collapse/menu-collapse.component';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
interface InstitucionResponse {
  data: {
    representanteLegal: {
      nombreRepresentanteLegal: string;
      IdentificacionRepresentante: string;
    };
    nombre: string;
    razonSocial: string;
    identificacion: string;
  };
}

@Component({
  selector: 'app-vertical-menu',
  imports: [CommonModule, SharedModule, MenuGroupVerticalComponent, MenuItemVerticalComponent, MenuCollapseComponent, RouterModule],
  templateUrl: './vertical-menu.component.html',
  styleUrls: ['./vertical-menu.component.scss']
})
export class VerticalMenuComponent {
  private location = inject(Location);
  private locationStrategy = inject(LocationStrategy);
  private themeService = inject(ThemeLayoutService);
  public authenticationService = inject(AuthenticationService);
  private http = inject(HttpClient);

  // public props
  readonly menus = input<NavigationItem[]>();
  showUser: false;
  showContent = true;
  direction: string = 'ltr';
  idInstitucion: any;
  roleUsuario: string;
  public razonSocial: string;

  // Constructor
  constructor() {
    effect(() => {
      this.updateThemeLayout(this.themeService.layout());
    });
    effect(() => {
      this.isRtlTheme(this.themeService.directionChange());
    });
    this.idInstitucion = this.authenticationService.currentUserIdInstitucio;

    this.razonSocial = this.authenticationService.currentUserValue.datos_empresa.razonSocial;
    if (this.authenticationService.currentUserValue.role == 'Admin') {
      this.roleUsuario = 'Administrador del servicio';
      //   this.razonSocial = 'PlanMarket S.A.';
    } else if (this.authenticationService.currentUserValue.role == 'AdminEmp') {
      this.roleUsuario = 'Administrador';
      //   this.razonSocial = this.authenticationService.currentUserValue.datos_empresa.razonSocial;
    } else if (this.authenticationService.currentUserValue.role == 'User') {
      this.roleUsuario = 'Usuario';
      //   this.razonSocial = this.authenticationService.currentUserValue.datos_empresa.razonSocial;
    }

    this.obtenerInstituciones();
  }

  async obtenerInstituciones(): Promise<void> {
    const parametros = {
      id: this.idInstitucion
    };

    this.http
      .post<{
        codigo: number;
        mensaje: string;
        data: any;
      }>('http://192.168.0.32:4200/api/cheqex/ObtenerInstitucion', parametros)
      .subscribe((respuesta) => {
        let data = respuesta.data;
        if (data == null) {
          return;
        }
        localStorage.setItem('IdentificacionRepresentante', JSON.stringify(data.representanteLegal.IdentificacionRepresentante));
        localStorage.setItem('razonSocial', JSON.stringify(data.razonSocial));
        localStorage.setItem('rucEmpresa', JSON.stringify(data.identificacion));
        localStorage.setItem('empresaIdentificacion', JSON.stringify(data.identificacion));
      });
  }

  // public method
  fireOutClick() {
    let current_url = this.location.path();
    const baseHref = this.locationStrategy.getBaseHref();
    if (baseHref) {
      current_url = baseHref + this.location.path();
    }
    const link = "a.nav-link[ href='" + current_url + "' ]";
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement;
      const up_parent = parent?.parentElement?.parentElement;
      const last_parent = up_parent?.parentElement;
      if (parent?.classList.contains('coded-hasmenu')) {
        parent.classList.add('coded-trigger');
        parent.classList.add('active');
      } else if (up_parent?.classList.contains('coded-hasmenu')) {
        up_parent.classList.add('coded-trigger');
        up_parent.classList.add('active');
      } else if (last_parent?.classList.contains('coded-hasmenu')) {
        last_parent.classList.add('coded-trigger');
        last_parent.classList.add('active');
      }
    }
  }

  private updateThemeLayout(layout: string) {
    if (layout == VERTICAL) {
      this.showContent = true;
    }
    if (layout == HORIZONTAL) {
      this.showContent = false;
    }
    if (layout == COMPACT) {
      this.showContent = false;
    }
  }

  private isRtlTheme(direction: string) {
    this.direction = direction;
  }

  // user Logout
  logout() {
    this.authenticationService.logout();
  }
  nombre: string = '';

  get avatarUrl(): string {
    if (this.authenticationService.currentUserName == 'jbenalcazar') {
      this.nombre = 'Juan';
    }
    if (this.nombre == 'Juan') {
      return `assets/images/user/avatar-${this.nombre}.jpg`;
    } else {
      return `assets/images/user/avatar-1.png`;
    }
  }
}
